import { createReducer } from "redux-act";

import {
  REQNotificationList,
  RESNotificationList,
  FailNotificationList,
  SENDxNotification,
  DELxNotification,
  SETxNotificationStatus,
  CleanUpNotificationList,
  RESEventCounts,
  REQCsatSetting,
  REQSaveCsatSetting,
  RESCsatSetting,
  FailCsatSetting
} from "./actions";

const initialState = {
  REQStrNotificationList: false,
  NotificationList: [],
  Pagination: { page: 1, limit: 20, total: 0, totalPages: 0 },
  errorMessage: false,
  EventCounts: {},
  CsatSetting: null,
  CsatSettingError: false
};

const notificationListReducer = createReducer(
  {
    [REQNotificationList]: (state, payload) => {
      // The background refresh swaps the rows in place: no loading overlay while it runs.
      if (payload && payload.silent) {
        return state;
      }
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [SENDxNotification]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [DELxNotification]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [SETxNotificationStatus]: state => {
      return {
        ...state,
        REQStrNotificationList: true,
        errorMessage: false
      };
    },

    [RESNotificationList]: (state, payload) => {
      return {
        ...state,
        REQStrNotificationList: false,
        NotificationList: payload.data || [],
        Pagination: payload.pagination || initialState.Pagination,
        errorMessage: false
      };
    },

    [FailNotificationList]: (state, payload) => {
      return {
        ...state,
        REQStrNotificationList: false,
        errorMessage: (payload && payload.message) || "โหลดรายการแจ้งเตือนไม่สำเร็จ"
      };
    },

    [REQCsatSetting]: state => {
      return { ...state, CsatSettingError: false };
    },

    [REQSaveCsatSetting]: state => {
      return { ...state, CsatSettingError: false };
    },

    [RESCsatSetting]: (state, payload) => {
      return { ...state, CsatSetting: payload || null, CsatSettingError: false };
    },

    [FailCsatSetting]: (state, payload) => {
      return { ...state, CsatSettingError: (payload && payload.message) || "Could not load the CSAT settings" };
    },

    [RESEventCounts]: (state, payload) => {
      return {
        ...state,
        EventCounts: payload || {}
      };
    },

    [CleanUpNotificationList]: () => {
      return initialState;
    }
  },

  initialState
);

export default notificationListReducer;
